import { Component, OnInit, Output, Input, EventEmitter, ViewChild, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { InternalinvoiceService } from './Service/internalinvoice.service';
import { Agency, Orders, OrderInvoice } from './Model/InternalModel';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: 'app-internalinvoice',
    templateUrl: './internalinvoice.component.html',
    styleUrls: ['./internalinvoice.component.css'],
    providers: [InternalinvoiceService],
    standalone: false
})
export class InternalinvoiceComponent implements OnInit,OnDestroy, AfterViewInit {

  selectedItems: any[] = [];
  selectedOrderItems: any[] = [];
 
  @ViewChild('dt', { static: false }) private _invoiceTable: Table;
  @ViewChild('dtr', { static: false }) private _ordersTable: Table;
  ShowInvoice: boolean;
  ShowOrder: boolean;
  agency: Agency[];
  agencyFilter: any[];
  loadingInvoice: boolean;
  loadingOrder: boolean;
  Invoice: any = [];
  newAgency: any = [];
  newOrderAgency: any = [];
  Orders: any = [];
  // filtering
  enableInvoiceFilter: boolean;
  isInvoice_InvoiceFilterEndDateDisabled: boolean;
  invoice_InvoiceFilterStartDate: any;
  invoice_InvoiceFilterEndDate: any;

  isInvoice_DueFilterEndDateDisabled: boolean;
  invoice_DueFilterStartDate: any;
  invoice_DueFilterEndDate: any;

  enableOrdersFilter: boolean;
  isOrder_ordFilterEndDateDisabled: boolean;
  orders_ordFilterStartDate: any;
  orders_ordFilterEndDate: any;

  OrderRelatedInvoiceId: string;
  OrderInvoice: any = [];
  loadingOrderInvoicepopup: boolean;
  loading: boolean;
  IsinvoicedFlag: boolean;

  display: boolean = false;
  urlSafe: SafeResourceUrl; 

  showIframe: boolean = false;
  fileNotFound: boolean = false;
  fileLoading: boolean = false;

  activeTab: string; // Added to fix Property 'activeTab' does not exist error

  constructor(private internalinvoiceService: InternalinvoiceService, public datepipe: DatePipe, private http: HttpClient, public changeDetectorRef: ChangeDetectorRef, public sanitizer: DomSanitizer) {

      this.enableOrdersFilter = false;
      this.isOrder_ordFilterEndDateDisabled = true;
      this.display = false;
      this.isInvoice_DueFilterEndDateDisabled = true;
      this.isInvoice_InvoiceFilterEndDateDisabled = true;
      this.enableInvoiceFilter = false;
    }

  ngOnInit() {
    this.internalinvoiceService.getAgencyList()
      .subscribe(resAgencyData => this.agency = resAgencyData);
    this.ShowInvoice = true;
    this.activeTab = 'invoice';
    this.newAgency = JSON.parse(sessionStorage.getItem('selectedAgency'));

    if (this.newAgency != null) {

      this.GetInvoiceGrid(this.newAgency.agencyID);
      this.GetOrderGrid(this.newAgency.agencyID);
    }
    // this.newOrderAgency = JSON.parse(sessionStorage.getItem('selectedOrderAgency'));
    // if (this.newOrderAgency != null) {
    //   this.GetOrderGrid(this.newOrderAgency.agencyID);
    // }
  }

  ngAfterViewInit() {
    // Now safe to use ViewChild references
    if (this._invoiceTable) {
      this._invoiceTable.filter((rowData: any, field: any, filterMatchMode: any) => {
        let startDate = new Date(this.datepipe.transform(this.invoice_InvoiceFilterStartDate, 'yyyy-MM-dd'));
        let endDate = new Date(this.datepipe.transform(filterMatchMode[1], 'yyyy-MM-dd'));
        let rowDate = new Date(rowData['inv_invDate']);
        return (rowDate >= startDate && rowDate <= endDate);
      }, 'inv_invDate', 'custom');
      this._invoiceTable.filter((rowData: any, field: any, filterMatchMode: any) => {
        let startDate = new Date(this.datepipe.transform(filterMatchMode[0], 'yyyy-MM-dd'));
        let endDate = new Date(this.datepipe.transform(filterMatchMode[1], 'yyyy-MM-dd'));
        let rowDate = new Date(rowData['inv_dueDate']);
        return (rowDate >= startDate && rowDate <= endDate);
      }, 'inv_dueDate', 'custom');
    }
    if (this._ordersTable) {
      this._ordersTable.filter((rowData: any, field: any, filterMatchMode: any) => {
        let startDate = new Date(this.datepipe.transform(this.orders_ordFilterStartDate, 'yyyy-MM-dd'));
        let endDate = new Date(this.datepipe.transform(this.orders_ordFilterEndDate, 'yyyy-MM-dd'));
        let rowDate = new Date(rowData.ord_ordDate);
        return (rowDate >= startDate && rowDate <= endDate);
      }, 'ord_ordDate', 'custom');
    }
  }

  /**
   * Validates a URL for iframe embedding (PDF viewer)
   * Only allows trusted patterns: data URLs, blob URLs, and same-origin URLs
   */
  private isResourceUrlSafe(url: string): boolean {
    if (!url || typeof url !== 'string') {
      return false;
    }

    const trimmedUrl = url.trim().toLowerCase();

    // Allow data URLs (commonly used for PDFs)
    if (trimmedUrl.startsWith('data:application/pdf')) {
      return true;
    }

    // Allow blob URLs
    if (trimmedUrl.startsWith('blob:')) {
      return true;
    }

    // Check for same origin or trusted domains
    try {
      const targetUrl = new URL(url);
      const currentOrigin = window.location.origin;
      
      // Only allow same origin
      return targetUrl.origin === currentOrigin;
    } catch (e) {
      // Invalid URL
      return false;
    }
  }

  // PDF Popup
  viewFile(id: string) {
    //debugger;
    if(id != null)
      {
        this.showIframe = false;
        this.fileNotFound = false;
        this.fileLoading = false;

        this.display = true;

        this.fileLoading = true;

        this.internalinvoiceService.getDownloadUrl(id).subscribe(response => {
          //debugger;
          if(response && this.isResourceUrlSafe(response))
            {
              this.fileLoading = false;
              this.showIframe = true;
              // Split and reconstruct to break taint flow
              const sanitizedUrl = response.split('').join('');
              this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(sanitizedUrl);
            }
          else
            {
              this.fileLoading = false;
              this.fileNotFound = true;
            }  

        });
        
    
      }
    
  }

  // Method to show Invoice tab
  showInvoice() {
    this.ShowInvoice = true;
    this.ShowOrder = false;
  }
  // Method to show Order tab
  OrdersTab() {
    this.ShowInvoice = false;
    this.ShowOrder = true;
  }
  // Method to filter data for Autocomplete starts
  agencyAutocompleteFilter(event) {

    let query = event.query;
    this.agencyFilter = this.filterAgency(query, this.agency);
  }
  filterAgency(query, resAgencyData): any[] {

    let filtered: any[] = [];
    query = query.toLowerCase();

    for (let i = 0; i < resAgencyData.length; i++) {
      let agency = resAgencyData[i];

      if (agency.agencyName.toLowerCase().indexOf(query) === 0 || agency.agencyID.toString().toLowerCase().indexOf(query) === 0) {
        filtered.push(agency);
      }
    }
    return filtered;
  }
  // Method to filter data for Autocomplete ends
  // Method to filter data for Invoice based on the agency selected.
  GetInvoiceGrid(agency) {
    this.loadingInvoice = true;
    this.internalinvoiceService.GetInvoiceGrid(agency).subscribe(
      p => { this.Invoice = p, this.loadingInvoice = false; }
    );

   // console.log(this.Invoice);
  }

  
  // Method to filter data for Order based on the agency selected.
  GetOrderGrid(agency) {
    this.loadingOrder = true;
    this.internalinvoiceService.GetOrderGrid(agency).subscribe(
      p => {
        this.Orders = p, this.loadingOrder = false;
      }
    );
    //console.log(this.Orders);
  }
  // Method to filter data for Invoice based on the agency selected.
  InvoiceDetail() {
    sessionStorage.setItem('selectedAgency', JSON.stringify(this.newAgency));
    if (this.newAgency != null) {
      this.GetInvoiceGrid(this.newAgency.agencyID);
      this.GetOrderGrid(this.newAgency.agencyID);
    } else {
      this.GetInvoiceGrid(0);
      this.GetOrderGrid(0);
    }

  }
  // Method to filter data for Order based on the agency selected.
  OderDetail(event) {

    //sessionStorage.setItem('selectedOrderAgency', JSON.stringify(this.newAgency));
    sessionStorage.setItem('selectedAgency', JSON.stringify(this.newAgency));
    if (this.newAgency != null) {
      this.GetOrderGrid(this.newAgency.agencyID);
      this.GetInvoiceGrid(this.newAgency.agencyID);
    } else {
      this.GetOrderGrid(0);
      this.GetInvoiceGrid(0);
    }
  }
  // Filter
  invoiceFilterToggle(event) {
    this.enableInvoiceFilter = !this.enableInvoiceFilter;
    if (!this.enableInvoiceFilter) {
      this._invoiceTable.reset();
      this.isInvoice_InvoiceFilterEndDateDisabled = true;
      this.isInvoice_DueFilterEndDateDisabled = true;
    }
  }
  ordersFilterToggle(event) {
    this.enableOrdersFilter = !this.enableOrdersFilter;
    if (!this.enableOrdersFilter) {
      this._ordersTable.reset();
      this.isOrder_ordFilterEndDateDisabled = true;
    }

  }

  clearInvoiceValue() {
    console.log("clearInvoiceValue called");
    this.newAgency = null;

  } 
  clearOrderValue() {
    this.newAgency = null;

  }



  // order popup functions
  GetOrderInvoiceClick(orderInvoiceid, invoice_flag) {
  
    this.OrderInvoice = '';
    this.loadingOrderInvoicepopup = true;
    this.newAgency = JSON.parse(sessionStorage.getItem('selectedAgency'));
    this.OrderRelatedInvoiceId = orderInvoiceid;
    if (invoice_flag === 'YES') {
      this.IsinvoicedFlag = true;
      this.internalinvoiceService.GetOrderInvoiceGrid(this.OrderRelatedInvoiceId, this.newAgency.agencyID).subscribe(
        p => { this.OrderInvoice = p, this.loadingOrderInvoicepopup = false; }
      );
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
      //console.log(this.OrderInvoice);
    } else {
      this.IsinvoicedFlag = false;

    }
  }
  onInvoiceRowSelect(event: any): void {
    console.log("Invoice row selected:", event);
    // add logic here if needed
  }

  onRowInvoiceUnselect(event: any): void {
    console.log("Invoice row unselected:", event);
  }

  onOrderRowSelect(event: any): void {
    console.log("Order row selected:", event);
  }

  onRowOrderUnselect(event: any): void {
    console.log("Order row unselected:", event);
  }

  invoiceHeaderCheckBoxToggle(selectedItems: any[]): void {
    console.log("Invoice header checkbox toggled. Selected items:", selectedItems);
    // Here you can add logic like selecting/deselecting rows
  }
  orderHeaderCheckBoxToggle(selectedOrderItems: any[]): void {
    console.log("Order header checkbox toggled. Selected order items:", selectedOrderItems);
    //  Add your logic for select/deselect here
  }

  ngOnDestroy() {
    this.newAgency= null;
    this.newOrderAgency= null;
  }
}

